import { gql } from '@apollo/client';

export default gql`
  mutation updateProcItem(
    $_id: String
    $branch: String
    $name: String
    $nameAr: String
    $disabled: Boolean
    $additionId: String
    $pcategoryId: String
    $pcategoryName: String
    $pcategoryNameAr: String
  ) {
    updateProcItem(
      _id: $_id
      branch: $branch
      name: $name
      nameAr: $nameAr
      disabled: $disabled
      additionId: $additionId
      pcategoryId: $pcategoryId
      pcategoryName: $pcategoryName
      pcategoryNameAr: $pcategoryNameAr
    ) {
      ok
      message
      data
      error
    }
  }
`;
